import { Timed } from "@fidget/common/utils/timed";

@Timed
export class FidgetService {
  private readonly orgId: string;
  private config?: Promise<any>;

  constructor(orgId: string) {
    this.orgId = orgId;
  }

  private graphql(query: string, variables: Record<string, any>): Promise<any> {
    return fetch("/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ query, variables }),
    }).then((r) => r.json()).then((r) =>
      (function toObjWithUndefineds(objWithNulls: any): any {
        return objWithNulls !== null && typeof objWithNulls === "object" && !Array.isArray(objWithNulls)
          ? Object.assign(
              {},
              ...Object.keys(objWithNulls).map((key) => {
                return {
                  [key]:
                    objWithNulls[key] === null ? undefined : toObjWithUndefineds(objWithNulls[key])
                };
              })
            )
          : objWithNulls;
      })(r.data[Object.keys(r.data)[0]!]));
  }

  async getConfig(): Promise<any> {
    if (!this.config) {
      this.config = this.graphql(`
        query config($orgId: String!) {
          config(orgId: $orgId) {
            org {
              id
              name
              color
              origin
              baseUrl
              coverToken
              logoToken
              meetingSlotSize
              maintenanceWindows {
                from
                to
                message
              }
              workingHours {
                offsetSeconds
                durationSeconds
              }
              languageLocale
              agreement
              agreementEnabled
              phoneRegion
              welcomeMessageEnabled
              welcomeMessagePl
              welcomeMessageEn
              headerWelcomeMessagePl
              headerWelcomeMessageEn
              autoAssignedLimit
              callsDisabled
              customerNotify
              typingPreviewEnabled
              openedConversationsMetricEnabled
              waitingConversationsMetricEnabled
              averageResponseTimeMetricEnabled
              openedConversationsSlaEnabled
              waitingConversationsSlaEnabled
              averageResponseTimeSlaEnabled
              openedConversationsSlaRangeLowerBound
              openedConversationsSlaRangeUpperBound
              waitingConversationsSlaRangeLowerBound
              waitingConversationsSlaRangeUpperBound
              averageResponseTimeSlaRangeLowerBound
              averageResponseTimeSlaRangeUpperBound
              cobrowseEnabled
              continueConversationOnMobileEnabled
              forgetMeEnabled
              defaultStatusAfterLogin
              oauthEnabled
              showAdviserLastNameEnabled
              autoreassignEnabled
              profanitiesCheckingEnabled
              keyboardShortcutsEnabled
              reportsEnabled
              autoFollowOnUnassign
              reassignOnLogoutEnabled
              statusChangeOnCloseEnabled
              snoozeOnRoomChange
              allowedAttachmentExtensions
              maximumAttachmentSizeBytes
              autoSnoozeTimeoutSeconds
              autoCloseTimeoutSeconds
              defaultAgentAvatarToken
              showAssignedAgentAvatarEnabled
              messageMaxAllowedCharactersForAgent
              messageMaxAllowedCharactersForClient
              contactEnquiryActionEnabled
              meetingActionEnabled
              webSpeechApiEnabled
              resetRoomViewOnClose
              autoReassignOnWebsocketUnavailable
              omniLink
              omniEnabled
              zoneId
              overrideStyles
              agentLogLevel
              widgetLogLevel
            }
            urlTagMappings {
              id
              urlPattern
              matchingStrategy
              tag
            }
            proactiveMessages {
              tag
              text
              langTag
              enabled
              displayOutsideWorkingHours
            }
            bot {
              id
              firstName
              lastName
              avatarToken
              presence
              isBot
              isActive
            }
          }
        }`,
        { orgId: this.orgId }
      );
    }
    return this.config;
  }

  async getTagGroup(id: string): Promise<any> {
    return this.graphql(`
      query tagGroup($id: String!) {
        tagGroup(id: $id) {
          id
          orgId
          name
          activeHours {
            offsetSeconds
            durationSeconds
          }
          tags
          attachmentsEnabled
          active
          showInConversationDetails
          autoSnoozeTimeoutSeconds
          autoCloseTimeoutSeconds
        }
      }`,
      { id }
    );
  }

  async checkLimit(): Promise<void> {
    return fetch("/limit").then((response) => {
      if (response.status === 200) {
        return;
      } else {
        throw response;
      }
    });
  }
}
